"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Truncate = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var react_truncate_1 = __importDefault(require("react-truncate"));
var Icon_1 = require("../Icon");
var TruncateWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n"], ["\n    width: 100%;\n"])));
var StyledButton = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: none;\n    border: 0;\n    padding: 5px;\n    margin: 0 0 0 5px;\n    cursor: pointer;\n    display: inline-block;\n    width: 25px;\n    height: auto;\n    position: relative;\n    top: 2px;\n    line-height: 1;\n"], ["\n    background: none;\n    border: 0;\n    padding: 5px;\n    margin: 0 0 0 5px;\n    cursor: pointer;\n    display: inline-block;\n    width: 25px;\n    height: auto;\n    position: relative;\n    top: 2px;\n    line-height: 1;\n"])));
var Truncate = function (_a) {
    var children = _a.children, _b = _a.lines, lines = _b === void 0 ? 1 : _b;
    var theme = styled_components_1.useTheme();
    var _c = react_1.useState(false), expanded = _c[0], setExpanded = _c[1];
    var _d = react_1.useState(false), truncated = _d[0], setTruncated = _d[1];
    var handleTruncate = function () {
        setTruncated(truncated);
    };
    var toggleLines = function (e) {
        e.preventDefault();
        setExpanded(!expanded);
    };
    return (react_1.default.createElement(TruncateWrapper, null,
        react_1.default.createElement(react_truncate_1.default, { lines: !expanded && lines, ellipsis: react_1.default.createElement("span", null,
                "...",
                ' ',
                react_1.default.createElement(StyledButton, { type: "button", onClick: toggleLines },
                    react_1.default.createElement(Icon_1.Icon, { icon: "ARROW_DOWN", color: theme.TYPE_DARK_GREY, size: 14 }))), onTruncate: handleTruncate }, children),
        !truncated && expanded && (react_1.default.createElement(StyledButton, { type: "button", onClick: toggleLines },
            react_1.default.createElement(Icon_1.Icon, { icon: "ARROW_UP", color: theme.TYPE_DARK_GREY, size: 14 })))));
};
exports.Truncate = Truncate;
var templateObject_1, templateObject_2;
